import React, { useState } from 'react';
import { XIcon, PencilIcon, SparklesIcon } from 'lucide-react';
type StoryReviewModalProps = {
  userInput: {
    foundation: {
      title: string;
      ageGroup: string;
      storyArc: string;
    };
    character: {
      name: string;
      special: string;
      type: string;
      description: string;
    };
    structure: {
      beginning: string;
      middle: string;
      ending: string;
    };
    style: {
      tone: string;
      inspiration: string;
      special: string;
      illustrationStyle: string;
    };
  };
  onClose: () => void;
  onEdit: (section: string) => void;
  onConfirm: () => void;
};
export const StoryReviewModal = ({
  userInput,
  onClose,
  onEdit,
  onConfirm
}: StoryReviewModalProps) => {
  const [aiSuggestions, setAiSuggestions] = useState({
    title: "The Dragon's Special Dance",
    character: 'A shy but determined dragon who loves to express themselves through dance',
    plot: 'When the annual forest talent show approaches, our dragon must overcome their fear of performing in front of others. With help from woodland friends and lots of practice, they learn that being yourself is the greatest talent of all.'
  });
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50" data-id="element-1005">
      <div className="bg-white rounded-2xl w-full max-w-3xl p-6" data-id="element-1006">
        <div className="flex items-center justify-between mb-6" data-id="element-1007">
          <h2 className="text-xl font-bold text-[#6B4B3E]" data-id="element-1008">
            Review Your Story
          </h2>
          <button onClick={onClose} className="p-2 hover:bg-[#FFF0E6] rounded-full transition-colors" data-id="element-1009">
            <XIcon size={20} className="text-[#6B4B3E]" data-id="element-1010" />
          </button>
        </div>
        <div className="space-y-6" data-id="element-1011">
          {/* Your Input Section */}
          <div className="bg-[#FFF0E6] rounded-xl p-6" data-id="element-1012">
            <div className="flex items-center justify-between mb-4" data-id="element-1013">
              <h3 className="text-lg font-bold text-[#6B4B3E]" data-id="element-1014">Your Ideas</h3>
              <button onClick={() => onEdit('all')} className="flex items-center text-[#D4A088] hover:text-[#C28B73]" data-id="element-1015">
                <PencilIcon size={16} className="mr-1" data-id="element-1016" />
                <span data-id="element-1017">Edit</span>
              </button>
            </div>
            <div className="space-y-4 text-[#6B4B3E]" data-id="element-1018">
              <p data-id="element-1019">
                <strong data-id="element-1020">Main Character:</strong>{' '}
                {userInput.character.description}
              </p>
              <p data-id="element-1021">
                <strong data-id="element-1022">Story Beginning:</strong>{' '}
                {userInput.structure.beginning}
              </p>
              <p data-id="element-1023">
                <strong data-id="element-1024">Main Event:</strong> {userInput.structure.middle}
              </p>
              <p data-id="element-1025">
                <strong data-id="element-1026">Ending:</strong> {userInput.structure.ending}
              </p>
            </div>
          </div>
          {/* Story Bunny's Suggestions */}
          <div className="bg-white border-2 border-[#E5C1A9] rounded-xl p-6" data-id="element-1027">
            <div className="flex items-center space-x-3 mb-4" data-id="element-1028">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/dgYPmgQZXQdrKaC8NJmmVJ/ChatGPT_Image_May_18%2C_2025_at_09_37_05_AM.png" alt="Story Bunny" className="w-8 h-8" data-id="element-1029" />
              <h3 className="text-lg font-bold text-[#6B4B3E]" data-id="element-1030">
                Story Bunny's Suggestions
              </h3>
            </div>
            <div className="space-y-4 text-[#6B4B3E]" data-id="element-1031">
              <div data-id="element-1032">
                <p className="font-medium mb-2" data-id="element-1033">Suggested Title:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1034">
                  {aiSuggestions.title}
                </p>
              </div>
              <div data-id="element-1035">
                <p className="font-medium mb-2" data-id="element-1036">Character Development:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1037">
                  {aiSuggestions.character}
                </p>
              </div>
              <div data-id="element-1038">
                <p className="font-medium mb-2" data-id="element-1039">Story Development:</p>
                <p className="bg-[#FFF0E6] p-3 rounded-lg" data-id="element-1040">
                  {aiSuggestions.plot}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="flex justify-end space-x-4 mt-8" data-id="element-1041">
          <button onClick={onClose} className="px-6 py-3 rounded-full border-2 border-[#E5C1A9] text-[#6B4B3E] hover:bg-[#FFF0E6] transition-colors" data-id="element-1042">
            Keep Editing
          </button>
          <button onClick={onConfirm} className="px-6 py-3 bg-[#D4A088] text-white rounded-full hover:bg-[#C28B73] transition-colors flex items-center" data-id="element-1043">
            <SparklesIcon size={20} className="mr-2" data-id="element-1044" />
            Create Story
          </button>
        </div>
      </div>
    </div>;
};